<template>
  <div>
    <div class="filter" style="border-bottom: 2px solid #335667">
      <el-form :model="filter" label-width="50px" label-position="top">
        <el-form-item label="年份">
          <el-date-picker
            size="small"
            type="years"
            value-format="yyyy"
            v-model="filter.years"
            placeholder="可多选"
            :picker-options="pickerOptions"
            :clearable="false"
            @change="
              getStatistics()
              getDurationStatistics()
            "
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="流程">
          <el-select
            v-model="flow_ids"
            :collapse-tags="true"
            multiple
            size="small"
            clearable
            filterable
            @change="getDurationStatistics()"
          >
            <el-option
              v-for="(v, k) in flowOptions"
              :key="k"
              :value="parseInt(k)"
              :label="v"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex mt-20" style="gap: 20px">
      <div style="width: 40%">
        <el-table
          size="mini"
          :data="tableData"
          v-loading="loading"
          show-summary
          stripe
          border
          sum-text="Total"
          :header-cell-style="{
            background: '#37717b',
            color: '#fff',
          }"
        >
          <el-table-column label="流程" prop="name" min-width="200px">
            <template slot-scope="scope">
              <span
                :class="{ 'text-primary pointer': scope.row.flow_id }"
                @click="handleFlowSelect({ flow_id: scope.row.flow_id })"
              >
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="未完成" prop="1990" align="right">
            <template slot-scope="scope">
              <div
                :class="{ 'text-primary pointer': scope.row.flow_id }"
                @click="
                  handleFlowSelect({ flow_id: scope.row.flow_id, status: 2 })
                "
              >
                {{ scope.row['1990'] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="year + '已完成'"
            :prop="year"
            align="right"
            :key="year"
            v-for="year in years"
            width="120px"
          >
            <template slot-scope="scope">
              <div
                :class="{ 'text-primary pointer': scope.row.flow_id }"
                @click="
                  handleFlowSelect({
                    flow_id: scope.row.flow_id,
                    status: 1,
                    years: [year],
                  })
                "
              >
                {{ scope.row[year] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Total" align="right" prop="total" sortable>
          </el-table-column>
        </el-table>
      </div>
      <div style="width: 60%">
        <ve-pie
          height="600px"
          :extend="pieExtend"
          :events="chartEvents"
          :colors="[
            '#37717b',
            '#84878f',
            '#ba956f',
            '#33486a',
            '#566a68',
            '#4a8764',
            '#9eb6c3',
            '#bfb0b6',
          ]"
        ></ve-pie>
      </div>
    </div>
  </div>
</template>

<script>
import { serviceQuestStatistics } from '@/service/getData'

export default {
  computed: {
    tableData() {
      let flowYears = this.groupBy(this.statistics, function (item) {
        return [item.service_quest_flow_id]
      })

      let data = flowYears.map((arr) => {
        let row = {
          name: arr[0].flow.name || '空',
          total: 0,
          flow_id: arr[0].service_quest_flow_id,
        }
        arr.map((item) => {
          row[item.format_date] = item.total
          row.total += item.total
        })
        return row
      })

      if (this.flow_ids.length > 0) {
        data = data.filter((item) => this.flow_ids.includes(item.flow_id))
      }

      data.sort(function (a, b) {
        return b.total - a.total
      })
      return data
    },
    pieExtend() {
      let rows = []
      this.tableData.map((item) => {
        if (item.name != '空') {
          rows.push({
            name: item.name,
            value: item.total,
            flow_id: item.flow_id,
          })
        }
      })
      return {
        title: {
          text: '',
          left: 'center',
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 'center',
          top: '70%',
          icon: 'circle',
          textStyle: {
            color: '#999',
          },
        },
        series: {
          type: 'pie',
          radius: '50%',
          data: rows,
          label: {
            normal: {
              formatter: '{c}（{d}%）',
            },
          },
        },
      }
    },
  },
  data() {
    return {
      loading: false,
      statistics: [],
      filter: {
        featrue_type: 1, //统计维度
        date_type: 1, //时间颗粒度
        years: [new Date().getFullYear().toString()],
      },
      flow_ids: [],
      flowOptions: {},
      pickerOptions: {},
      years: [],
      chartEvents: {
        click: this.chartHandleEvents,
      },
    }
  },
  created() {
    let that = this
    this.pickerOptions = {
      disabledDate: function (time) {
        return (
          that.$time(new Date()).isBefore(time) ||
          that.$time(time).isBefore('2025-01-01')
        )
      },
    }

    this.getStatistics()
  },
  methods: {
    chartHandleEvents(e) {
      this.$emit('tab', { flow_id: e.data.flow_id })
    },
    handleFlowSelect(condition = {}) {
      if (condition.flow_id) {
        this.$emit('tab', condition)
      }
    },
    async getStatistics() {
      if (this.filter.years.length == 0) {
        this.$alert('请至少选择一个年份!')
        return
      }
      if (this.filter.years.length > 0) {
        this.filter.years.sort()
      }
      let data = this.clone(this.filter)
      this.loading = true
      let res = await serviceQuestStatistics(data)

      let flowOptions = {}
      this.years = this.filter.years
      this.statistics = res.data

      res.data.map((item) => {
        if (!flowOptions[item.service_quest_flow_id]) {
          flowOptions[item.service_quest_flow_id] = item.flow.name || '无'
        }
      })
      this.flowOptions = flowOptions
      this.loading = false
    },
  },
}
</script>